import { Link } from "react-router-dom";

export default function CtaSection() {
  return (
    <section className="relative overflow-hidden bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="relative overflow-hidden rounded-lg bg-primary-600 px-6 py-10 md:px-12 md:py-14">
          <div className="absolute -right-16 -top-16 h-56 w-56 rounded-full bg-primary-500/50 blur-2xl"></div>
          <div className="absolute -bottom-20 -left-10 h-56 w-56 rounded-full bg-secondary-500/30 blur-2xl"></div>
          <div className="relative flex flex-col items-center gap-6 text-center">
            <h2 className="font-heading text-2xl text-background-50 md:text-4xl">
              现在开始，追更不迷路
            </h2>
            <p className="max-w-xl text-sm leading-relaxed text-primary-100 md:text-base">
              打开追番日历快速定位正在更新的作品，点开即看最新话，再也不用担心错过每一集更新。
            </p>
            <div className="flex flex-col gap-3 sm:flex-row">
              <Link
                to="/calendar"
                className="whitespace-nowrap rounded-full bg-background-50 px-6 py-3 text-sm font-bold text-primary-700 transition-colors hover:bg-background-100"
              >
                查看追番日历
              </Link>
              <Link
                to="/series"
                className="whitespace-nowrap rounded-full border border-background-50/40 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-background-50/10"
              >
                浏览本周新番
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}